/**
 * @fileoverview Shared date helpers for event feed message components.
 */

import formatDate from 'date-fns/format';

export type MessageDateValue = number | string | null | undefined;

/**
 * Normalizes a raw message timestamp into a reusable Date instance.
 * @param date A raw message timestamp as a number, date string, or nullish value.
 * @returns A parsed Date when the input is valid, otherwise null.
 */
export function getDateObject(date?: MessageDateValue): Date | null {
  if (date == null || date === '') {
    return null;
  }

  const dateObject = typeof date === 'number' ? new Date(date) : new Date(Date.parse(date));

  if (Number.isNaN(dateObject.getTime())) {
    return null;
  }

  return dateObject;
}

/**
 * Formats a parsed message Date with a date-fns v1 format string.
 * @param dateObject A previously parsed message Date.
 * @param formatString The date-fns v1 format string to apply.
 * @returns The formatted date string, or an empty string when no valid date is available.
 */
export function formatMessageDate(dateObject: Date | null, formatString: string): string {
  if (!dateObject) {
    return '';
  }

  return formatDate(dateObject, formatString);
}
